import { useEffect } from "react";
import { FuncionarioViewProps, mapDispatchToFuncionarioProps, mapStateToFuncionarioProps } from "../funcionario.controll";
import { Funcionario } from "../funcionario.model";
import { FuncionarioCadastro } from "./funcionario.cad";
import { Select as ViewList } from "../../../components/select";
import { GridColDef } from "@mui/x-data-grid";
import { Box, Typography } from "@mui/material";
import Modal from "../../../components/modal";
import { connect } from "react-redux";

const columns: GridColDef[] = [
    { field: 'nome', headerName: 'nome', flex: 3 },
    { field: 'apelido', headerName: 'Apelido', flex: 3 },
    { field: 'whatsapp', headerName: 'WhatsApp', flex: 2 },
    { field: 'n_doc', headerName: 'Documento', flex: 2 },
]


interface SelecionarFuncionarioProps extends FuncionarioViewProps {
    handleConfirmar: (funcionario: Funcionario) => any;
}

function SelecionarFuncionario(props: SelecionarFuncionarioProps) {
    const { funcionarioActions, funcionarioState, handleConfirmar } = props
    const { error, loading, msg, row, rows, showAlert, status, showCadModal, changeList, showSelectModal } = funcionarioState
    const { read, setShowAlert, setClearValue, setShowCadModal, setShowSelectModal } = funcionarioActions

    useEffect(() => {
        console.log("chamou Selecionar Funcionario")
        readFuncAtivos()
    }, [])

    const readFuncAtivos = () => {
        funcionarioActions.read({
            fieldsFilter: [
                { fieldName: "ativo", fieldValue: true, mangoQuery: "$eq" }
            ],
            indexName: "idx_funcionarios_ativo"
        });
    }

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    function Cadastro() {
        return FuncionarioCadastro({
            ...props,
            handleCloseView: () => setShowCadModal(false)
        }).renderModal({
            handleClose: () => setShowCadModal(false),
            show: showCadModal,
            heigth: "auto",
        })
    }

    const handleSelecionar = (funcionario: Funcionario) => {
        handleConfirmar(funcionario);
        setShowSelectModal(false);
    }

    const List = () => {
        return (
            <>
                <ViewList
                    displayWidth={window.innerWidth}
                    title={"Selecionar Funcionario"}
                    row={row}
                    showAlert={showAlert}
                    closeAlert={() => setShowAlert(false)}
                    msg={msg}
                    status={status}
                    elevation={1}
                    getRowId={(row: Funcionario) => row._id}
                    handleOnChange={handleSelecionar}
                    actionsOnkeyEnter={handleSelecionar}
                    showSearchContainer={true}
                    fontSize={20}
                    setTextSearch={() => { }}
                    textSearch={""}
                    fieldSearch={"nome"}
                    columns={columns}
                    rows={rows}
                    loading={loading}
                    setRow={handleSelecionar}
                    changeList={changeList}
                    buttonNew={{
                        show: true,
                        onClick: handleNovo
                    }}
                    buttonRefresh={{
                        show: true,
                        onClick: () => readFuncAtivos()
                    }}
                    ListItemTextPrimary={(row: Funcionario) => <Typography component={"span"}>{row.nome} {row.sobrenome}</Typography>}
                    ListItemTextSecondary={(row: Funcionario) =>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography component={"span"}>{row.apelido} {row.whatsapp}</Typography>
                        </Box>
                    }
                />
                <Cadastro />
            </>
        )
    }

    return (
        <Modal
            component={<List />}
            handleClose={() => setShowSelectModal(false)}
            open={showSelectModal}
            heigth="auto"
            width="sm"
            handleOnKeyDown={() => { }}
        />
    )
}

export default connect(mapStateToFuncionarioProps, mapDispatchToFuncionarioProps)(SelecionarFuncionario);